import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Spinner } from "./Neon";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthed, isAdmin, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Spinner className="min-h-[60vh]" />;
  if (!isAuthed) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (adminOnly && !isAdmin) return <Navigate to="/" replace />;
  return children;
};
